import { lazy, Suspense } from 'react';
import { ehErroDeChunkStale, ehErroDeRenderStale, recarregarBundleStale } from './bundleStale';

// Nunca resolve: segura o Suspense (tela em branco no lugar da página) até o reload.
const aguardarReload = () => new Promise(() => {});

/**
 * Página carregada sob demanda (um chunk por rota). Sem fallback visível: o shell
 * (sidebar/header) continua na tela enquanto o chunk chega, e a página mostra o
 * próprio skeleton ao montar.
 *
 * Bundle velho depois de deploy: o servidor pode devolver o index.html (200) no lugar
 * do chunk, e aí o import() resolve sem `default`. Nos dois casos (falha ou módulo
 * vazio) recarrega uma vez pra pegar o build novo — ver utils/bundleStale.
 */
export default function paginaLazy(importar) {
  const Pagina = lazy(() =>
    importar()
      .then((modulo) => {
        if (!modulo?.default) throw new Error('Failed to fetch dynamically imported module (empty)');
        return modulo;
      })
      .catch((erro) => {
        if ((ehErroDeChunkStale(erro) || ehErroDeRenderStale(erro)) && recarregarBundleStale()) {
          return aguardarReload();
        }
        throw erro;
      }),
  );

  return function PaginaLazy(props) {
    return (
      <Suspense fallback={null}>
        <Pagina {...props} />
      </Suspense>
    );
  };
}
